import { render } from "./rbqmInteligentDashboard.vue?vue&type=template&id=34881f2c&scoped=true"
import script from "./rbqmInteligentDashboard.js?vue&type=script&lang=js"
export * from "./rbqmInteligentDashboard.js?vue&type=script&lang=js"

import "./rbqmInteligentDashboard.vue?vue&type=style&index=0&id=34881f2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34881f2c"]])

export default __exports__